import { IfcBSplineCurve, IfcCompositeCurve, IfcConic, IfcIndexedPolyCurve, IfcLine, IfcOffsetCurve2D, IfcOffsetCurve3D, IfcPolyline, IfcTrimmedCurve } from "./ifc4_gen/index.js";
import { IfcCartesianPointList2D, IfcPcurve } from "./ifc4_gen/index.js";
/**
 *
 */
export function IfcPointListDim(pointList) {
    if (pointList instanceof IfcCartesianPointList2D) {
        return 2;
    }
    return 3;
}
// export function IfcAssociatedSurface(arg: IfcPcurve) : IfcSurface {
//     throw "This function is not yet implemented."
// }
/**
 *
 */
export function IfcBaseAxis(dim, axis1, axis2, axis3) {
    throw "This function is not yet implemented.";
}
/**
 *
 */
export function IfcBooleanChoose(b, choice1, choice2) {
    return b ? choice1 : choice2;
}
/**
 *
 */
export function IfcBuild2Axes(refDirection) {
    throw ["This function is not yet implemented."];
}
/**
 *
 */
export function IfcBuildAxes(axis, refDirection) {
    throw "This function is not yet implemented.";
}
// export function IfcConsecutiveSegments(segments: Array<IfcArcIndex|IfcLineIndex>) : boolean {
//     throw "This function is not yet implemented."
// }
/**
 *
 */
export function IfcConstraintsParamBSpline(degree, upKnots, upCp, knotMult, knots) {
    throw "This function is not yet implemented.";
}
/**
 *
 */
export function IfcConvertDirectionInto2D(direction) {
    throw "This function is not yet implemented.";
}
/**
 *
 */
export function IfcCorrectDimensions(m, dim) {
    throw "This function is not yet implemented.";
}
/**
 *
 */
export function IfcCorrectFillAreaStyle(styles) {
    throw "This function is not yet implemented.";
}
/**
 *
 */
export function IfcCorrectLocalPlacement(axisPlacement, relPlacement) {
    throw "This function is not yet implemented.";
}
/**
 *
 */
export function IfcCorrectObjectAssignment(constraint, objects) {
    throw "This function is not yet implemented.";
}
/**
 *
 */
export function IfcCorrectUnitAssignment(units) {
    throw "This function is not yet implemented.";
}
/**
 *
 */
export function IfcCrossProduct(arg1, arg2) {
    throw "This function is not yet implemented.";
}
/**
 *
 */
export function IfcCurveDim(curve) {
    if (curve instanceof IfcLine) {
        return curve.Pnt.Dim;
    }
    if (curve instanceof IfcConic) {
        return curve.Position.Dim;
    }
    if (curve instanceof IfcPolyline) {
        return curve.Points[0].Dim;
    }
    if (curve instanceof IfcTrimmedCurve) {
        return IfcCurveDim(curve.BasisCurve);
    }
    if (curve instanceof IfcCompositeCurve) {
        return curve.Segments[0].Dim;
    }
    if (curve instanceof IfcBSplineCurve) {
        return curve.ControlPointsList[0].Dim;
    }
    if (curve instanceof IfcOffsetCurve2D) {
        return 2;
    }
    if (curve instanceof IfcOffsetCurve3D) {
        return 3;
    }
    //NOTE: these seem to be from a newer schema version
    /*if (curve instanceof IfcOffsetCurveByDistances) {
  
    }
    if (curve instanceof IfcCurveSegment2D) {
  
    }
    if (curve instanceof IfcAlignmentCurve) {
  
    }*/
    if (curve instanceof IfcPcurve) {
        return 3;
    }
    if (curve instanceof IfcIndexedPolyCurve) {
        return curve.Points.Dim;
    }
    return 0;
}
// export function IfcCurveWeightsPositive(b: IfcRationalBSplineCurveWithKnots) : boolean {
//     throw "This function is not yet implemented."
// }
/**
 *
 */
export function IfcDeriveDimensionalExponents(unitElements) {
    throw "This function is not yet implemented.";
}
/**
 *
 */
export function IfcDimensionsForSiUnit(n) {
    throw "This function is not yet implemented.";
}
/**
 *
 */
export function IfcDotProduct(arg1, arg2) {
    let result = 0;
    for (let argIndex = 0, end = Math.min(arg1.Dim, arg2.Dim); argIndex < end; ++argIndex) {
        result += arg1.DirectionRatios[argIndex] * arg2.DirectionRatios[argIndex];
    }
    return result;
}
/**
 *
 */
export function IfcFirstProjAxis(zAxis, arg) {
    throw "This function is not yet implemented.";
}
/**
 *
 */
export function IfcGetBasisSurface(c) {
    throw "This function is not yet implemented.";
}
/**
 *
 */
export function IfcListToArray(lis, low, u) {
    throw "This function is not yet implemented.";
}
/**
 *
 */
export function IfcLoopHeadToTail(aLoop) {
    throw "This function is not yet implemented.";
}
/**
 * Takes a 2D array
 */
export function IfcMakeArrayOfArray(lis, low1, u1, low2, u2) {
    const result = [];
    for (let u = low1; u < u1; ++u) {
        const toAdd = [];
        for (let v = low2; v < u2; ++v) {
            toAdd.push(lis[v][u]);
        }
        result.push(toAdd);
    }
    return result;
}
/**
 *
 */
export function IfcMlsTotalThickness(layerSet) {
    throw "This function is not yet implemented.";
}
/**
 *
 */
export function IfcNormalise(arg) {
    throw "This function is not yet implemented.";
}
/**
 *
 */
export function IfcOrthogonalComplement(vec) {
    throw "This function is not yet implemented.";
}
/**
 *
 */
export function IfcPathHeadToTail(aPath) {
    throw "This function is not yet implemented.";
}
// export function IfcPointListDim(pointList: IfcCartesianPointList) : IfcDimensionCount {
//     throw "This function is not yet implemented."
// }
/**
 *
 */
export function IfcSameAxis2Placement(ap1, ap2, epsilon) {
    throw "This function is not yet implemented.";
}
/**
 *
 */
export function IfcSameCartesianPoint(cp1, cp2, epsilon) {
    throw "This function is not yet implemented.";
}
/**
 *
 */
export function IfcSameDirection(dir1, dir2, epsilon) {
    throw "This function is not yet implemented.";
}
/**
 *
 */
export function IfcSameValidPrecision(epsilon1, epsilon2) {
    throw "This function is not yet implemented.";
}
/**
 *
 */
export function IfcSameValue(value1, value2, epsilon) {
    throw "This function is not yet implemented.";
}
/**
 *
 */
export function IfcScalarTimesVector(scalar, vec) {
    throw "This function is not yet implemented.";
}
/**
 *
 */
export function IfcSecondProjAxis(zAxis, xAxis, arg) {
    throw "This function is not yet implemented.";
}
/**
 *
 */
export function IfcShapeRepresentationTypes(repType, items) {
    throw "This function is not yet implemented.";
}
// export function IfcSurfaceWeightsPositive(b: IfcRationalBSplineSurfaceWithKnots) : boolean {
//     throw "This function is not yet implemented."
// }
/**
 *
 */
export function IfcTaperedSweptAreaProfiles(startArea, endArea) {
    throw "This function is not yet implemented.";
}
/**
 *
 */
export function IfcTopologyRepresentationTypes(repType, items) {
    throw "This function is not yet implemented.";
}
/**
 *
 */
export function IfcUniqueDefinitionNames(relations) {
    throw "This function is not yet implemented.";
}
/**
 *
 */
export function IfcUniquePropertyName(properties) {
    throw "This function is not yet implemented.";
}
/**
 *
 */
export function IfcUniquePropertySetNames(properties) {
    throw "This function is not yet implemented.";
}
// export function IfcUniquePropertyTemplateNames(properties: Array<IfcPropertyTemplate>) : boolean {
//     throw "This function is not yet implemented."
// }
/**
 *
 */
export function IfcUniqueQuantityNames(properties) {
    throw "This function is not yet implemented.";
}
/**
 *
 */
export function IfcVectorDifference(arg1, arg2) {
    throw "This function is not yet implemented.";
}
/**
 *
 */
export function IfcVectorSum(arg1, arg2) {
    throw "This function is not yet implemented.";
}
